<nz-page-header nzTitle="Forms" nzSubtitle="Select the form you want to view or edit">
</nz-page-header>

<button nz-button nzType="dashed" class="mb-1" (click)="add()">
        + Add Form
</button>

<nz-table nzSize="small" [nzData]="[]" [nzFrontPagination]="false">

        <thead>
                <tr>
                        <th>Name</th>
                        <th>Description</th>
                </tr>
        </thead>

        <tbody>
        </tbody>

</nz-table>